import { CountryType } from "../types/airgraft";
import { addSentryClientExtra, reportSentryClientError } from "./sentry";

export async function subscribeToNewsletter(
  email: string,
  country: CountryType,
  subcountry: string,
  category?: "newsletter" | "medical"
) {
  const host = process.env.GATSBY_NETLIFY_FUNCTIONS_BASE_URL || "";
  const response = await fetch(
    `${host}/.netlify/functions/newsletter-subscribe`,
    {
      method: "post",
      body: JSON.stringify({
        email,
        country,
        subcountry,
        category: category || "newsletter"
      })
    }
  );
  if (response.ok) {
    return true;
  } else {
    const e = new Error("Something went wrong trying to subscribe your email");
    addSentryClientExtra("netlifyResponseCode", response.statusText);
    reportSentryClientError(e);
    throw e;
  }
}
